import type { Match } from "navigo";
import type { ChildDom } from "vanjs-core";
import { reactive } from "vanjs-ext";
import { errorSection } from "../error-section";
import { loadingScreen } from "../loading-screen";
import { t } from "../locale";
import type { Route, RouteContext } from "../router";
import { state } from "../state";
import { userPlaceholder } from "../user/user";
import { centeredBox } from "../van/centered-box";
import { button, div, h1, p } from "../van/van-tags";

export class DeleteAccountPage implements Route {
	async #deleteUser(): Promise<void> {
		const req = this.#ctx.api.delete(`/users/${this.#reactive.user.Id}`);
		req.setSignedInUserAuth();

		const res = await loadingScreen.waitFor(req.do());
		if (res.ok) {
			state.signOut();
			this.#ctx.router.jump("/sign-in");
		} else if (res.status === 403) {
			errorSection.setText(await res.text());
		}
	}

	async refresh(_: Match): Promise<void> {
		this.#reactive.user = await state.getActiveUser();
	}

	#ctx: RouteContext;
	#reactive = reactive({
		user: userPlaceholder,
	});

	ChildDom: ChildDom;

	constructor(ctx: RouteContext) {
		this.#ctx = ctx;
		this.ChildDom = centeredBox(
			{ size: "narrow" },
			h1({ class: "title" }, () => t.accountDeletionPage.header),
			div(
				{ class: "field" },
				p(() => t.accountDeletionPage.disclaimer),
			),
			div(
				{
					class: "field is-grouped is-multiline",
				},
				div(
					{ class: "control" },
					button(
						{
							class: "button is-danger",
							onclick: () => this.#deleteUser(),
						},
						() => t.confirm,
					),
				),
				div(
					{
						class: "control",
						onclick: () => {
							this.#ctx.router.jump("/account");
						},
					},
					button({ class: "button" }, t.back),
				),
			),
		);
	}
}
